import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-fztype-list-view',
  imports: [],
  templateUrl: './fztype.list-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FztypeListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
